import styled from 'styled-components';
import { RefreshButton, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { DiscardedEmptyState } from 'ui/illustrations';
import { useTranslation } from '../../hooks/useTranslation';

type Props = {
  refresh: () => void;
  isRefreshing: boolean;
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
`;

const Title = styled.div`
  ${({ theme }) => theme.styles.headings.heading4};
  font-size: ${({ theme }) => theme.styles.fontSizes.s18};
  padding: ${({ theme }) => theme.spacing.values.threeQuarter};
`;

const Description = styled.div`
  ${({ theme }) => theme.styles.body.body2};
  align-items: center;
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.values.threeQuarter}; ;
`;

const StyledRefreshButton = styled(RefreshButton)`
  flex-direction: row;
  column-gap: 0;
`;

export const ErrorMessage = ({ refresh, isRefreshing }: Props) => {
  const { t } = useTranslation();
  const loadingMessage = isRefreshing ? t('errorBoundary.loading') : t('errorBoundary.refresh');

  return (
    <Wrapper>
      <DiscardedEmptyState />
      <Title>{t('errorBoundary.title')}</Title>
      <Description>
        <div>{t('errorBoundary.subtitle')}</div>
        <div>{t('errorBoundary.description')}</div>
      </Description>
      <StyledRefreshButton
        onClick={refresh}
        isRefreshing={isRefreshing}
        isDisabled={isRefreshing}
        variant={BUTTON_VARIANTS.PRIMARY}
        size={BUTTON_SIZES.MEDIUM}
      >
        {loadingMessage}
      </StyledRefreshButton>
    </Wrapper>
  );
};
